// extracted by mini-css-extract-plugin
export var chip = "_52-0";
export var filterDropdown = "_52-5";
export var filterItem = "_52-6";
export var icon = "_52-1";
export var removeButton = "_52-3";
export var removeIcon = "_52-4";
export var separator = "_52-2";